<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="d-flex">
          <div v-if="singleMember.avatar" class="widget--avatar">
            <img :src="singleMember.avatar" alt="user avatar" />
          </div>
          <div v-else class="widget--avatar">
            <span>{{ singleMember.firstName[0] }}</span>
          </div>
          <div class="widget--details-wrapper">
            <h4>{{ singleMember.firstName }} {{ singleMember.lastName }}</h4>
            <div class="row">
              <div class="col">
                <p v-if="singleMember.email">
                  <img
                    src="~@/assets/media/icons/email.svg"
                    alt="email icon"
                  />{{ singleMember.email }}
                </p>
                <p v-if="singleMember.mobile">
                  <img
                    src="~@/assets/media/icons/call.svg"
                    alt="phone icon"
                  />{{ singleMember.mobile }}
                </p>
                <p v-if="isOwnerOfCompany">
                  <img src="~@/assets/media/icons/loft.svg" alt="loft icon" />
                  Owner
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!isOwnerOfCompany">
        <div class="col">
          <div class="form-group text-right mb-0">
            <ActionButton
              label="Remove from company"
              class="btn-danger"
              :theme="errorPallete"
              @customEvent="deleteUserFromCompany"
              style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import _ from "lodash";

export default {
  name: "ViewMemberProfile",
  components: {
    ActionButton
  },
  props: {
    modalParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      errorPallete: {
        main: "#dc3545",
        event: "#c82333"
      },
      singleMember: {},
      singleRecord: {}
    };
  },
  created() {
    this.singleMember = this.modalParams.member;
    this.singleRecord = this.modalParams.singleRecord;
  },
  computed: {
    isOwnerOfCompany() {
      return _.find(this.singleMember.UserMeta, {
        key: `owner:group-${this.singleRecord.id}`
      })
        ? true
        : false;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    ...mapActions({
      GROUP_DELETE_MEMBER: "GROUP_DELETE_MEMBER"
    }),
    async deleteUserFromCompany() {
      let userId = this.singleMember.id;
      let groupId = this.singleRecord.id;
      this.GROUP_DELETE_MEMBER({ userId, groupId });
      this.$toastr.success("Your changes are saved", "Success");
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.widget--avatar {
  margin-right: 30px;
  span {
    align-items: center;
    background-color: $brand-primary;
    border-radius: 50%;
    color: $white;
    display: flex;
    font-family: "Gotham";
    font-size: $font-size-xl;
    font-weight: 500;
    height: 110px;
    justify-content: center;
    width: 110px;
  }
  img {
    border-radius: 50%;
    display: block;
    height: 110px;
    object-fit: cover;
    width: 110px;
  }
}
.widget--details-wrapper {
  h4 {
    color: $gray-900;
    font-size: $font-size-md;
    font-weight: 500;
    margin-bottom: 10px;
  }
  p {
    align-items: flex-start;
    display: flex;
    font-family: "Gotham Book";
    font-size: $font-size-sm;
    img {
      margin-right: 10px;
      height: 20px;
      width: 20px;
    }
    &.-muted {
      color: $gray-550;
    }
  }
}
</style>
